/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
import { forceUpdate } from "@stencil/core";
import { createObserver } from "./observers";
let mutationObserver;
const observerOptions = { childList: true };
/**
 * Helper to set up a conditional slot component on connectedCallback.
 *
 * @param component
 * @deprecated Use `onSlotchange` event with `slotChangeHasAssignedElement` DOM utility instead.
 *
 * ```
 * <slot onSlotchange={(event) => this.mySlotHasElement = slotChangeHasAssignedElement(event)} />}
 * ```
 */
export function connectConditionalSlotComponent(component) {
    if (!mutationObserver) {
        mutationObserver = createObserver("mutation", processMutations);
    }
    mutationObserver.observe(component.el, observerOptions);
}
/**
 * Helper to tear down a conditional slot component on disconnectedCallback.
 *
 * @param component
 * @deprecated Use `onSlotchange` event with `slotChangeHasAssignedElement` DOM utility instead.
 *
 * ```
 * <slot onSlotchange={(event) => this.mySlotHasElement = slotChangeHasAssignedElement(event)} />}
 * ```
 */
export function disconnectConditionalSlotComponent(component) {
    mutationObserver.unobserve(component.el);
}
function processMutations(mutations) {
    mutations.forEach(({ target }) => {
        forceUpdate(target);
    });
}
//# sourceMappingURL=conditionalSlot.js.map
